import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication, EventType, type AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { applyTheme, readStoredTheme } from './lib/theme.js';
import { App } from './App.js';
import { msalConfig, isAuthConfigured } from './authConfig.js';
import './styles.css';

// Set before the first paint, so the page never flashes the wrong theme.
applyTheme(readStoredTheme());

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);

if (!isAuthConfigured) {
  root.render(
    <div className="signin">
      <div className="signin-card">
        <h1>24IT Growth Engine</h1>
        <p>
          Authentication is not configured for this build. VITE_GE_TENANT_ID and
          VITE_GE_AUTH_CLIENT_ID must be supplied at build time.
        </p>
      </div>
    </div>,
  );
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  void msalInstance.initialize().then(() => {
    const account = msalInstance.getAllAccounts()[0];
    if (account) msalInstance.setActiveAccount(account);

    msalInstance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
      }
    });

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>,
    );
  });
}
